export class ClaimRewardPostModel {
  public rewardId: number;
  public name: string;
  public address: string;
  public zipCode: string;
  public city: string;
}
